import angular from "angular";
angular.module("cardspotWeb.areas.transferCard", ["angular.emlpayments"]);